import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const mcbookieColors: ThemeTailwindType = {
    '--primary': '148 83% 45%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '222 47% 11%',
};

const colorPalette: ColorPaletteType = {
    primary: '#0d1a33',
    secondary: '#13d26c',
    tertiary: '#3c8edb',
    dark: '#060c18',
    shade1: '#003366',
    shade2: '#154674',
    shade3: '#d9e3ec',
    shade4: '#e3eaf1',
    shade5: '#edf2f6',
    shade6: '#f8f9fb',
    textDark: '#111111',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.secondary,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.primary,
        bgColorQuaternary: colorPalette.tertiary,

        borderColor: colorPalette.primary,
        borderColorSecondary: colorPalette.tertiary,

        txtColor: colorPalette.textDark,
        txtColorSecondary: colorPalette.textDark,
        txtColorTertiary: colorPalette.textDark,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.textDark,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#0d1a33',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#13d26c',
        buttonTxtColor: '#060C18',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
